import { render, staticRenderFns } from "./TransProject.vue?vue&type=template&id=41779be4&scoped=true"
import script from "./TransProject.vue?vue&type=script&lang=js"
export * from "./TransProject.vue?vue&type=script&lang=js"
import style0 from "./TransProject.vue?vue&type=style&index=0&id=41779be4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41779be4",
  null
  
)

export default component.exports